<template lang="pug">
#layoutShell(ref="heightBody")
    header.header-global(ref="HeaderGlobalHeight" v-if="showHeader")
        .header-global__logo
            .logo
                router-link(to="/")
                    //- img(src="./assets/logo-vw.svg")
                    img(:src="logo_global_header")
        
        .header-global__action(v-if="auth_data.role && (auth_data.role.label === 'superadmin' || auth_data.role.label === 'operator')")
            button.mobile-only.cta-mobile(
                v-on:click="mobileSearch = !mobileSearch"
                )
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            div.full-screen-mobile.header-action-content(
                v-bind:class="{'is-show': mobileSearch}"
            )   
                header.mobile-only.p-4
                    .flex.items-center.justify-between
                        h2 Search the target
                        button.btn-icon.btn-icon-40(
                            @click="closeTargetSearch()"
                        )
                            .icon-btn
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                headerAction

        router-link.mobile-only.cta-mobile(to="/media")
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        .header-global__menus
            button.mobile-only.cta-mobile(v-on:click="mobileMenu = !mobileMenu")
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            div.full-screen-mobile.header-menu-content(
                v-bind:class="{'is-show': mobileMenu}"
            )
                button.close-menu.mobile-only(v-on:click="mobileMenu = !mobileMenu")
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                headerMenu
    section.section-global
        keep-alive
            router-view
</template>

<script>
import { mapState } from 'vuex';
import headerAction from './components/shell/header/globalAction.vue'
import headerMenu from './components/shell/header/globalMenu.vue'

import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/messaging'
// import axios from 'axios'
import { encrypt,decrypt } from '@/util/crypto';

export default {
    name: 'layoutShell',
    components: {
        headerAction,
        headerMenu,
    },
    // metaInfo: {
    //     title: process.env.VUE_APP_APP_NAME,
    //     // titleTemplate: '%s | vue-meta Example App',
    // },
    metaInfo() {
        return {
            title: this.$store.getters.getTitleGlobal,
        };
    },
    data() {
        return {
            // logo_global_header: (process.env.VUE_APP_ASTRO === 'true' ? '/logo-astro.svg' : process.env.VUE_APP_APP_LOGO_GLOBAL_HEADER),
            // favicon: (process.env.VUE_APP_ASTRO === 'true' ? '/logo-a.ico' : process.env.VUE_APP_APP_FAVICON),
            logo_global_header: this.$store.getters.getLogoGlobalHeader,
            favicon: this.$store.getters.getFavicon,
            mobileSearch: false,
            mobileMenu: false,
            // notification_data: null,
        };
        
    },
    computed: {
        ...mapState([
            'auth_data',
        ]),
        showHeader() {
            let result = true;
            if (this.$route.name === 'pageLogin' || this.$route.name === 'pageForgotPassword' || this.$route.name === 'pageResetPassword' || this.$route.name === 'PageNotFound' || this.$route.name === 'PageForbidden') {
                result = false;
            }
            return result;
        },
    },
    watch: {
        showHeader() {},
    },
    created() {
        // set icon
        // const favicon = document.querySelector('head link[rel="icon"]');
        // console.log(favicon)
        // console.log(this.favicon)
        // favicon.setAttribute('href', this.favicon);
        // favicon.setAttribute('type', 'image/ico');
        // console.log(favicon)

        // set theme
        // const style_global = document.getElementById('style_global');

        // if (process.env.VUE_APP_ASTRO === 'true') {
        //     style_global.setAttribute('class', 'skin-blue-dark');
        // } else {

        //     if (process.env.VUE_APP_THEME) {
        //         style_global.setAttribute('class', process.env.VUE_APP_THEME);
        //     } else {
        //         style_global.setAttribute('class', 'skin-default');
        //     }
        // }
        // ----------------------------------------------------------------

        const config = {
            apiKey: this.$fcmConfig.API_KEY,
            authDomain: this.$fcmConfig.AUTH_DOMAIN,
            databaseURL: this.$fcmConfig.DATABASE_URL,
            projectId: this.$fcmConfig.PROJECT_ID,
            storageBucket: this.$fcmConfig.STORAGE_BUCKET,
            messagingSenderId: this.$fcmConfig.SENDER_ID,
            appId: this.$fcmConfig.APP_ID,
            measurementId: this.$fcmConfig.MEASUREMENT_ID,
        };

        firebase.initializeApp(config)

        let messaging = firebase.messaging()

        messaging.usePublicVapidKey(this.$fcmConfig.PUBLIC_VAPID_KEY)

        // Vue.prototype.$messaging = firebase.messaging()

        // navigator.serviceWorker.register('/firebase-messaging-sw.js')
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then((registration) => {
            // console.log('serviceWorker registered', registration)
            // Vue.prototype.$messaging.useServiceWorker(registration)
            messaging.useServiceWorker(registration)
          }).catch(err => {
            console.log(err)
          })


        // let active_token;

        var self = this;
        messaging.requestPermission().then(() => {
          console.log('Notification permission granted.')

          messaging.getToken().then((token) => {
            // console.log('New token created: ', token)
            self.$store.commit('setFcmToken', token);
            self.$store.dispatch('fcmSubscribeToTopic');
            // this.saveNotificationToken(token)
          })
        }).catch((err) => {
          console.log('Unable to get permission to notify.', err)
        })

        messaging.onTokenRefresh(function () {
          messaging.getToken().then(function (newToken) {
            // console.log('Token refreshed: ', newToken)
            self.$store.commit('setFcmToken', newToken);
            self.$store.dispatch('fcmSubscribeToTopic');
            // this.saveNotificationToken(newToken)
          }).catch(function (err) {
            console.log('Unable to retrieve refreshed token ', err)
          })
        })

        messaging.onMessage(function(payload) {
            // console.log("Message received. ", payload);
            if (self.$route.name !== 'PageNotification')
                self.$store.dispatch('getNotificationCount');

            if (self.$route.name === 'PageNotification')
                EventEmit.$emit('notificationOnPageNotification');

            let data = null;
            let type = payload.data.type;

            if (payload.data && payload.data.data && typeof payload.data.data === 'string') {
                // console.log(payload.data.data);
                data = JSON.parse(payload.data.data);
            }
            //  else {
            //     data = payload.data.data ? payload.data.data : 'no data';
            // }

            // console.log(payload.data.data ? typeof payload.data.data : 'no data');
            // console.log(JSON.parse(payload.data));
            // console.log(data);
            // console.log(type);

            if (payload.data && payload.data.type && data !== null) {
                self.$swal.fire({
                    icon: 'info',
                    title: payload.notification.title,
                    // text: payload.notification.body,
                    // html: '<br>' + payload.notification.body,
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        // update notification count

                        toast.addEventListener('mouseenter', self.$swal.stopTimer)
                        toast.addEventListener('mouseleave', self.$swal.resumeTimer)

                        toast.addEventListener('click', function() {
                            // console.log('notif clicked')
                            self.clickNotification(type, data);
                        });
                    }
                });
            }

            // ...
        });

        // console.log('this.$store.state.auth_data')
        // console.log(this.$store.state.auth_data)
    },

    methods: {
        async clickNotification(type, data) {
            // console.log('on clickNotification()');
            // console.log(type);
            // console.log(data);

            if (type === 'territory_virtual') {
                // console.log(this.$route.name)
                // console.log(this.$route.params.id)
                // console.log('check data fcm')
                // console.log(data.data)

                for (var j = 0; j < data.data.length; j++) {
                    if(data.data[j].key == 'target') {
                        var target = JSON.parse(data.data[j].value);
                    } else if(data.data[j].key == 'territory_virtual_id') {
                        var territory_virtual_id = data.data[j].value;
                    }
                    //  else if(data.data[j].key == 'history_territory_virtual_id') {
                    //     var history_territory_virtual_id = data.data[j].value;
                    // }
                }

                if (this.$route.name === 'PageTerritoryVirtualDetailNotification') {
                    if (this.$route.params.id === territory_virtual_id && this.$route.params.target_id === target.id && decrypt(this.$route.params.msisdn) === target.msisdn) {
                        // console.log('on same id && target_id && msisdn')
                        EventEmit.$emit('territoryNotificationOnDetail');
                    } else {
                        // console.log('on same page')
                        this.$router.push({ name: 'PageTerritoryVirtualDetailNotification', params: { id: territory_virtual_id, target_id: target.id, msisdn: encrypt(target.msisdn) } });
                    }
                } else {
                    // console.log('on different page')
                    this.$router.push({ name: 'PageTerritoryVirtualDetailNotification', params: { id: territory_virtual_id, target_id: target.id, msisdn: encrypt(target.msisdn) } });
                }
            } else if (type === 'meeting_point') {
                // console.log("data.data.length")
                // console.log(data.data.length)

                for (var i = 0; i < data.data.length; i++) {
                    if(data.data[i].key == 'meeting_point_id') {
                        var meetingPointId = data.data[i].value
                    } else if(data.data[i].key == 'multi_tracking_id') {
                        var multiTrackingId = data.data[i].value
                    }
                }
                if (this.$route.name === 'PageMultiTrackingMeetingPoint') {
                    if ((this.$route.params.id === data.multiTrackingId) && (this.$route.params.idMeet === data.meetingPointId)) {
                        // console.log('on same id')
                        EventEmit.$emit('meetingPointNotification');
                    } else {
                        // console.log('on same page')
                        this.$router.push({ name: 'PageMultiTrackingMeetingPoint', params: { id: multiTrackingId, idMeet: meetingPointId } });
                    }
                } else {
                    // console.log('on different page')
                    this.$router.push({ name: 'PageMultiTrackingMeetingPoint', params: { id: multiTrackingId, idMeet: meetingPointId } });
                }
            }

            // update notification count
            await this.$store.dispatch('getUpdateNotification', data.id)
            .then(() => {
                this.$store.dispatch('getNotificationCount');
            });
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
        // saveNotificationToken(token) {
        //   const registerNotifTokenURL = '/register-notif-token/'
        //   const payload = {
        //     registration_id: token,
        //     type: 'web'
        //   }
          
        //   axios.post(registerNotifTokenURL, payload)
        //     .then((response) => {
        //       console.log('Successfully saved notification token!')
        //       console.log(response.data)
        //     })
        //     .catch((error) => {
        //       console.log('Error: could not save notification token')
        //       if (error.response) {
        //         console.log(error.response.status)
        //         // Most of the time a "this field must be unique" error will be returned,
        //         // meaning that the token already exists in db, which is good.
        //         if (error.response.data.registration_id) {
        //           for (let err of error.response.data.registration_id) {
        //             console.log(err)
        //           }
        //         } else {
        //           console.log('No reason returned by backend')
        //         }
        //         // If the request could not be sent because of a network error for example
        //       } else if (error.request) {
        //         console.log('A network error occurred.')
        //         // For any other kind of error
        //       } else {
        //         console.log(error.message)
        //       }
        //     })
        //   },
        closeTargetSearch(){
            EventEmit.$emit('mobileSearchClose')
        }
    },
    mounted() {
        EventEmit.$on('mobileSearchClose', () => {
            this.mobileSearch = false
        });
        EventEmit.$on('mobileMenuClose', () => {
            this.mobileMenu = false
        });
    },
}
</script>

<style lang="sass">
// @import "./assets/sass/themes/skin-default.sass"
// @import "./assets/sass/themes/skin-red.sass"
// @import "./assets/sass/themes/skin-red-dark.sass"
// @import "./assets/sass/themes/skin-blue-dark.sass"
@import "./assets/sass/responsive.sass"
*
    padding: 0
    margin: 0
    box-sizing: border-box
input,
select,
textarea
button
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"

a
    text-decoration: none

a,
button
    transition: all 0.3s ease
    cursor: pointer
    background: transparent
    border: none
    outline: none
    display: inline-block

.monospace
    font-family: 'Inconsolata', monospace

.btn-primary-o
    border: 1px solid #2E9C46
    color: #2E9C46
    border-radius: 4px
    &:hover
        background-color: #2E9C46
        color: #fff

ul, ol
    list-style: none
    padding: 0
    margin: 0

$color-primary: #40bb5b

body
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
    background-color: #F5F9FD
    font-size: 1rem
    font-weight: 400
    line-height: 1.5
    color: #2e2e2e
    padding-top: 48px

.mobile-only
    display: none

.header-global
    position: fixed
    top: 0
    left: 0
    right: 0
    width: 100%
    height: 48px
    border-bottom: 1px solid #ddd
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0px 8px
    background: #111C27
    color: #F5F9FD
    font-size: 13px
    z-index: 999
    &__action
        flex-grow: 1

.logo
    width: 100px
    height: 32px
    // background: #2E9C46
    display: flex
    align-items: center
    a
        height: 100%
        width: auto
        img
            height: 100%
            width: auto

.tooltip
    display: block !important
    z-index: 10000

    .tooltip-inner
        max-width: 300px
        text-align: center
        // background: black
        background-color: rgba(0, 0, 0, 0.8)
        color: white
        // border-radius: 16px
        border-radius: 5px
        // padding: 5px 10px 4px
        padding: 10px

    .tooltip-arrow
        width: 0
        height: 0
        border-style: solid
        position: absolute
        margin: 5px
        border-color: black
        z-index: 1

    &[x-placement^="top"]
        margin-bottom: 5px

    .tooltip-arrow
        border-width: 5px 5px 0 5px
        border-left-color: transparent !important
        border-right-color: transparent !important
        border-bottom-color: transparent !important
        bottom: -5px
        left: calc(50% - 5px)
        margin-top: 0
        margin-bottom: 0

    &[x-placement^="bottom"]
        margin-top: 5px

    .tooltip-arrow
        border-width: 0 5px 5px 5px
        border-left-color: transparent !important
        border-right-color: transparent !important
        border-top-color: transparent !important
        top: -5px
        left: calc(50% - 5px)
        margin-top: 0
        margin-bottom: 0

    &[x-placement^="right"]
        margin-left: 5px

    .tooltip-arrow
        border-width: 5px 5px 5px 0
        border-left-color: transparent !important
        border-top-color: transparent !important
        border-bottom-color: transparent !important
        left: -5px
        top: calc(50% - 5px)
        margin-left: 0
        margin-right: 0

    &[x-placement^="left"]
        margin-right: 5px

    .tooltip-arrow
        border-width: 5px 0 5px 5px
        border-top-color: transparent !important
        border-right-color: transparent !important
        border-bottom-color: transparent !important
        right: -5px
        top: calc(50% - 5px)
        margin-left: 0
        margin-right: 0

    &[aria-hidden='true']
        visibility: hidden
        opacity: 0
        transition: opacity .15s, visibility .15s

    &[aria-hidden='false']
        visibility: visible
        opacity: 1
        transition: opacity .15s

// loading on sweetalert2
.save_loading
    width: 140px
    height: 140px
    margin: 0 auto
    animation-duration: 0.5s
    animation-timing-function: linear
    animation-iteration-count: infinite
    animation-name: loadingSweetalert2
    transform-origin: 50% 50%

@keyframes loadingSweetalert2
    100%
        transform: rotate(-360deg) translate(0,0)

// error on form input
.error
    // border-color: red
    // background: #FDD
    color: red

.error:focus
    outline-color: #F99

.text-link
    color: $color-primary

// google maps css
.gm-style .gm-style-iw-c
    color: #2b404e
// .gm-style .gm-style-iw-t::after
//     background: linear-gradient(45deg,rgb(43, 64, 78) 50%,rgba(255,255,255,0) 51%,rgba(255,255,255,0) 100%)

</style>
